export default __webpack_public_path__ + "static/media/kinder13.82f97fda.jpg";